import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
    methods: {
    ...mapActions([
        "updateContent",
        "addNewChecklistItem",
        "removeChecklistItem",
        "initArticleEdit",
        "clearArticleEdit"
    ]),
    addChecklistItem() {
        this.addNewChecklistItem(this.content);
        if(!this.trHeight) this.trSetHeight(null);
        this.$nextTick(() => {
            this.trAddHeight(this.$refs.row[0].offsetHeight);
        });
    },
    removeItem(item) {
        let payload = { content: this.content, item: item };
        this.removeChecklistItem(payload);
        if(!this.trHeight) this.trSetHeight(null);
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    checkBoxValue: function(checkBoxId){
        const checkBox = this.content.items.find(item => item.id == checkBoxId);
        const userId = JSON.parse(localStorage.getItem("user")).user.id;
        return checkBox.checkedForContact.find(x => x == userId) ? true : false;
    },
    updateCheckListValue: function(checkBoxId){
        let content = this.content;
        let checkBox = content.items.find(item => item.id == checkBoxId);
        const userId = JSON.parse(localStorage.getItem("user")).user.id;
        if(checkBox.checkedForContact.find(x => x == userId))
          checkBox.checkedForContact.splice(checkBox.checkedForContact.findIndex(x => x == userId), 1);
        else
          checkBox.checkedForContact.push(userId);
  
        const article = this.$store.getters.getArticleBySectionId(content.section_id);
        this.initArticleEdit(article.id);
        this.updateContent(content);
        this.$store.dispatch('updateArticle', article);
        this.clearArticleEdit();
      },
      checkAllValues: function(){
            this.content.items.forEach(item => {
            if (!this.checkBoxValue(item.id)) {
                    this.updateCheckListValue(item.id);
                }
            });
        return true;
      },
      uncheckAllValues: function() {
            this.content.items.forEach(item => {
                // Sätt värdet till false istället för true
                this.updateCheckListValue(item.id, false);
            });
       }
    }
}